import { useState, useEffect, useContext } from 'react';
import './styles.css';
import { useParams, useHistory } from 'react-router-dom';
import { stepsPerfil, stepsPerfilGestor } from '../Tour/steps';
import { useTour } from '@reactour/tour';
import UserContext from '../../context/UserContext'; // Importa o contexto do usuário
import api from 'src/services/api';

export default function EditarUsuario() {
    const { id } = useParams();
    const history = useHistory();
    const { userData } = useContext(UserContext); // Obtém os dados do usuário logado
    const { setSteps } = useTour();

    const [formData, setFormData] = useState({
        nomeCompleto: '',
        email: '',
        funcao: [],
        usuario: '',
        senha: ''
    });

    const [isProjectManager, setIsProjectManager] = useState(false); // Verifica se o usuário logado é gestor
    const [ funcoesDisponiveis ] = useState([
        "Back",
        "Cientista de dados",
        "Designer UI/UX",
        "Desenvolvedor Front/Back",
        "DevOPS",
        "Engenheiro de dados",
        "Gerente de Projetos",
        "Product Owner",
        "Stakeholder"
    ]);

    const [showOptions, setShowOptions] = useState(false);

    useEffect(() => {
        // Verifica se o usuário logado é gestor
        if (userData?.user?.isProjectManager) {
            setIsProjectManager(true);
            setSteps(stepsPerfilGestor);
        } else {
            setIsProjectManager(false);
            setSteps(stepsPerfil);
        }
    }, [userData, setSteps]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem('auth-token');
                const userInfoResponse = await api.get(`/api/user/information/${id}`, {
                    headers: { 'x-auth-token': token }
                });

                const userRolesResponse = await api.get(`/api/user/roles/${id}`, {
                    headers: { 'x-auth-token': token }
                });

                let rolesArray = [];
                if (Array.isArray(userRolesResponse.data)) {
                    rolesArray = userRolesResponse.data
                        .filter(role => role && typeof role === 'string')
                        .map(role => role.trim().replace(/^{+|}+$/g, '').replace(/^"+|"+$/g, ''))
                        .filter(role => role !== "");
                } else if (typeof userRolesResponse.data === 'object') {
                    rolesArray = Object.values(userRolesResponse.data)
                        .filter(role => role && typeof role === 'string')
                        .map(role => role.trim().replace(/^{+|}+$/g, '').replace(/^"+|"+$/g, ''))
                        .filter(role => role !== "");
                }

                setFormData({
                    nomeCompleto: userInfoResponse.data.nome || '',
                    email: userInfoResponse.data.email || '',
                    funcao: rolesArray,
                    usuario: userInfoResponse.data.usuario_colaborador || '',
                    senha: ''
                });
            } catch (error) {
                console.error('Erro ao buscar informações do usuário:', error);
            }
        };

        fetchUserData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('auth-token');
            if (formData.senha.trim() !== '') {
                await api.patch(`/api/user/change-password/${id}`, {
                    novaSenha: formData.senha
                }, 
                {
                    headers: { 'x-auth-token': token }
                });
            }

            await api.post(`/api/user/roles/${id}`, {
                roles: formData.funcao
            },
            {
                headers: { 'x-auth-token': token }
            });
            alert('Alterações salvas com sucesso!');
            history.goBack();
        } catch (error) {
            console.error('Erro ao alterar a senha:', error);
            alert('Erro ao alterar a senha. Tente novamente.');
        }
    };

    const handleDelete = async (e) => {
        e.preventDefault();

        const confirmDelete = window.confirm('Tem certeza que deseja excluir este usuário? Esta ação não poderá ser desfeita.');

        if (!confirmDelete) {
            return;
        }

        try {
            const token = localStorage.getItem('auth-token');
            await api.patch(`/api/user/${id}`, {}, {
                headers: { 'x-auth-token': token }
            });
            alert('Usuário excluído com sucesso!');
            history.goBack();
        } catch (error) {
            console.error('Erro ao excluir o usuário:', error);
            alert('Erro ao excluir o usuário. Tente novamente.');
        }
    };

    const handleCancel = () => {
        history.goBack();
    };

    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    const handleSelectFunction = (funcao) => {
        if (!formData.funcao.includes(funcao)) {
            setFormData({
                ...formData,
                funcao: [...formData.funcao, funcao]
            });
        }
        setShowOptions(false);
    };

    const removeFunction = (funcaoToRemove) => {
        setFormData({
            ...formData,
            funcao: formData.funcao.filter(f => f !== funcaoToRemove)
        });
    };

    return (
        <div className="container">
            <p className="font-semibold text-3xl mb-14 border-b pb-6 pl-8">Editar Usuário</p>
            <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-6 ml-5 mr-5">
                {/* Primeira linha com Nome, E-mail e Função */}
                <div>
                    <label className="font-semibold text-sm" htmlFor="nome">Nome completo</label>
                    <input 
                        type="text" 
                        className="w-full border rounded px-3 py-2" 
                        id="nome" 
                        name="nomeCompleto" 
                        value={formData.nomeCompleto} 
                        readOnly
                        style={{ cursor: 'not-allowed' }}
                        placeholder="Nome e Sobrenome" 
                    />
                </div>
                <div>
                    <label className="font-semibold text-sm" htmlFor="email">E-mail</label>
                    <input 
                        type="email" 
                        className="w-full border rounded px-3 py-2" 
                        id="email" 
                        name="email" 
                        value={formData.email} 
                        readOnly
                        style={{ cursor: 'not-allowed' }}
                        placeholder="fulano@gmail.com" 
                    />
                </div>

                <div>
                    <label className="font-semibold text-sm" htmlFor="funcao">Função (Taiga):</label>
                    {isProjectManager ? (
                        <div className="relative">
                            <div 
                                className="w-full border border-[#b9b9b9] rounded px-3 py-2.5 bg-white cursor-pointer flex items-center justify-between"
                                onClick={toggleOptions}
                            >
                                <div className="flex flex-wrap gap-2">
                                    {formData.funcao.length > 0 ? (
                                        formData.funcao.map((funcao, index) => (
                                            <div
                                                key={index}
                                                className="bg-blue-100 text-blue-800 px-2 py-1 rounded flex items-center gap-2 text-sm"
                                            >
                                                {funcao}
                                                <button
                                                    type="button"
                                                    className="text-red-500 hover:text-red-700"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        removeFunction(funcao);
                                                    }}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))
                                    ) : (
                                        <span className="text-gray-400">Selecione...</span>
                                    )}
                                </div>
                                <svg 
                                    className={`fill-current h-4 w-4 transform ${showOptions ? 'rotate-180' : ''}`} 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                </svg>
                            </div>
                            
                            {showOptions && (
                                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg">
                                    {funcoesDisponiveis
                                        .filter(funcao => !formData.funcao.includes(funcao))
                                        .map((funcao, index) => (
                                            <div
                                                key={index}
                                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                onClick={() => handleSelectFunction(funcao)}
                                            >
                                                {funcao}
                                            </div>
                                        ))}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="w-full border border-[#b9b9b9] rounded px-3 py-2 bg-gray-100">
                            <div className="text-sm text-gray-500 py-1">
                                {formData.funcao.length === 0 ? "Nenhuma função atribuída" : formData.funcao.join(", ")}
                            </div>
                        </div>
                    )}
                </div>

                {/* Segunda linha com Usuário e Senha */}
                <div>
                    <label className="font-semibold text-sm" htmlFor="usuario">Usuário</label>
                    <input 
                        type="text" 
                        className="w-full border rounded px-3 py-2" 
                        id="usuario" 
                        name="usuario" 
                        value={formData.usuario} 
                        readOnly
                        style={{ cursor: 'not-allowed' }}
                        placeholder="fulano.sobrenome" 
                    />
                </div>
                <div>
                    <label className="font-semibold text-sm" htmlFor="senha">Senha</label>
                    <input 
                        type="password" 
                        className="w-full border rounded px-3 py-2" 
                        id="senha" 
                        name="senha" 
                        value={formData.senha} 
                        onChange={handleChange} 
                        placeholder="********" 
                    />
                </div>

                {/* Botões alinhados na última linha */}
                <div className='col-span-3 flex justify-end gap-6'>
                    {isProjectManager ? (
                        <div>
                            <button
                                type="button" 
                                className="bg-[#3B3B3B] hover:bg-black text-white py-2 px-4 rounded w-full" 
                                onClick={handleDelete}
                            >
                                Excluir Usuário
                            </button>
                        </div>
                    ) : (
                        <div></div>
                    )}
                    <div>
                        <button 
                            type="button" 
                            className="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded w-full" 
                            onClick={handleCancel}
                        >
                            Cancelar
                        </button>
                    </div>
                    <div>
                        <button 
                            type="submit" 
                            className="bg-[#00293B] hover:bg-[#00202e] text-white py-2 px-4 rounded w-full"
                        >
                            Salvar Alterações
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}